import React, { Component } from 'react';
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { mainSlider } from "../../../services/script";
import ReactPlayer from "react-player";

class Banner extends Component{
    render(){
        const {mainBanner, themeLayoutId, matches} = this.props
        return(
            <React.Fragment>

                {/* Fashion Theme */}

                {themeLayoutId === 'L01' && 

                <Slider {...mainSlider} className="slide-1 home-slider">
                {!!mainBanner &&
                  mainBanner.map((banner) => {
                   return (  
                   <div key={banner.Description.APP_PAGE_ID}>
                     <Link to={`${banner.Image.APC_ACTION_TYPE}/${banner.Image.BRAND_LIST}/${banner.Image.APC_ACTION_URL}`}>
                     {matches && ( <p
                      className="home text-center"
                      style={{
                        backgroundImage:
                          "url(" + banner.Image.APC_ELEMENT_CONTENT + ")",backgroundSize:'100% 450px'
                      }}
                    >{""}</p>)}
                    {!matches && ( <img
                      className=""
                      style={{
                        maxWidth: '100%',
                        minWidth: '320px',
                        height: 'auto',
                        margin: '0 auto'
                      }}
                      src={banner.Image.APC_MOBILE_SHOP_ELEMENT_CONTENT }
                    />)}
                   
                    </Link>
                  </div>
                   )
                  })
                }
                </Slider>
                }

                {/* end Fashion Theme */}

                {/* Furniture Theme Start */}

                {themeLayoutId === 'L02' && 
                    <section className="p-0 small-slider">
                    <Slider {...mainSlider} className="slide-1 home-slider">
                        {!!mainBanner && mainBanner.map((infocus) => {
                                return (
                                    <div key={infocus.Image.APP_PAGE_ID}>
                                        <div className="home home12 text-left" style={{ backgroundImage: 'url(' + infocus.Image.APC_ELEMENT_CONTENT + ')' }}>
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="slider-contain">
                                                            <div>
                                                                <h4>{infocus.Title.APC_ELEMENT_CONTENT}</h4>
                                                                <h1>{infocus.Description.APC_ELEMENT_CONTENT}</h1>
                                                                <Link to={`${infocus.Image.APC_ACTION_TYPE}/${infocus.Image.APC_ACTION_URL}`} className="btn btn-solid">shop now</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </section>
                }

                {/* end Furniture Theme */}

                {/* Beauty Theme */}

                {themeLayoutId === 'L03' && 
                <section className="p-0">
                    <Slider {...mainSlider} className="slide-1 home-slider">
                        {!!mainBanner && mainBanner.map((infocus) => {
                                return (
                                    <div key={infocus.Image.APP_PAGE_ID}>
                                        {
                                            (infocus.Image.APC_ELEMENT_CONTENT !== null || infocus.Image.APC_ELEMENT_CONTENT !== '')  && 
                                        
                                        <div className="home home34" style={{ backgroundImage: 'url(' + infocus.Image.APC_ELEMENT_CONTENT + ')' }}>
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="slider-contain">
                                                            <div>
                                                                <h4>{infocus.Title.APC_ELEMENT_CONTENT}</h4>
                                                                <h1>{infocus.Description.APC_ELEMENT_CONTENT}</h1>
                                                                <Link to={`${infocus.Image.APC_ACTION_TYPE}/${infocus.Image.APC_ACTION_URL}`} className="btn btn-solid">shop now</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        {
                                            infocus.Image.APC_ELEMENT_ID === "Video" && infocus.Image.APC_ELEMENT_CONTENT !== null &&
                                    
                                            <div>
                                                <div tabindex="-1" style={{width: '100%', display: 'inline-block'}}>
                                                <ReactPlayer 
                                                    id="background-video" 
                                                    className="home position-relative p-center  text-center overflow-hidden videoClass"
                                                    url={infocus.Video.APC_ELEMENT_CONTENT}    
                                                    playing={false}
                                                    autoPlay={false} 
                                                    muted={false} 
                                                    controls
                                                />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </section>
                }

                {/* end Beauty Theme */}

                {/* Pet Theme */}

                { themeLayoutId === 'L04' &&
                
                <section className="p-0 small-slider">
                    <Slider {...mainSlider} className="slide-1 home-slider">
                        {!!mainBanner && mainBanner.map((infocus) => {
                                return (
                                    <div key={infocus.Image.APP_PAGE_ID}>

                                        <div className="home home46" style={{ backgroundImage: 'url(' + infocus.Image.APC_ELEMENT_CONTENT + ')' }}>
                                            <div className="container" >
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="slider-contain">
                                                            <div>
                                                                <h4>{infocus.Title.APC_ELEMENT_CONTENT}</h4>
                                                                <h1>{infocus.Description.APC_ELEMENT_CONTENT}</h1>
                                                                {/* <h1>Save 20%</h1> */}
                                                                <Link to={`${infocus.Image.APC_ACTION_TYPE}/${infocus.Image.APC_ACTION_URL}`} className="btn btn-solid">shop now</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </section>
                }

                {/* End Pet Theme */}

                {/* Kids Theme */}

                {themeLayoutId === 'L05' &&
                <>
                <section className="p-0">
                    <Slider {...mainSlider} className="slide-1 home-slider">
                        {!!mainBanner && mainBanner.map((infocus) => {
                                return (
                                    <div key={infocus.Image.APP_PAGE_ID}>
                                        <div className="home home21 text-center p-right" style={{ backgroundImage: 'url(' + infocus.Image.APC_ELEMENT_CONTENT + ')' }}>
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="slider-contain">
                                                            <div>
                                                                <h4>{infocus.Title.APC_ELEMENT_CONTENT}</h4>
                                                                <h1>{infocus.Description.APC_ELEMENT_CONTENT}</h1>
                                                                <Link to={`${infocus.Image.APC_ACTION_TYPE}/${infocus.Image.APC_ACTION_URL}`} className="btn btn-solid">shop now</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </section>
                <section className="banner-padding absolute-banner pb-0 ratio2_1">
                    <div className="container absolute-bg">
                        <div className="row partition2">
                            <div className="col-md-6">
                            <Link to="/">
                                <div className="collection-banner p-right text-center">
                                <div>
                                    <img src="https://react.pixelstrap.com/multikart/assets/images/kids/2.jpg" className="img-fluid  bg-img" alt="" />
                                </div>
                                <div className="contain-banner">
                                    <div>
                                        <h4>save 30%</h4>
                                        <h2>outfits</h2>
                                    </div>
                                </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-6">
                            <Link to="/">
                                <div className="collection-banner p-right text-center">
                                <div>
                                    <img src="https://react.pixelstrap.com/multikart/assets/images/kids/1.jpg" className="img-fluid blur-up lazyload bg-img" alt="" />
                                </div>
                                <div className="contain-banner">
                                    <div>
                                        <h4>save 60%</h4>
                                        <h2>toys</h2>
                                    </div>
                                </div>
                                </div>
                            </Link>
                        </div>
                        </div>
                    </div>
                </section>
                </>
                }

                {/* end Kids Theme */}
                

            </React.Fragment>
        )
    }
}

export default Banner